__turbopack_context__.v({
  "button": "pnaTxa_button",
  "buttonText": "pnaTxa_buttonText",
  "container": "pnaTxa_container",
  "fixedSection": "pnaTxa_fixedSection",
  "fixedSectionContent": "pnaTxa_fixedSectionContent",
  "fixedSectionLabel": "pnaTxa_fixedSectionLabel",
  "icon": "pnaTxa_icon",
  "messageContainer": "pnaTxa_messageContainer",
  "recipientInput": "pnaTxa_recipientInput",
  "recipientLabel": "pnaTxa_recipientLabel",
  "recipientsSection": "pnaTxa_recipientsSection",
  "sendButtonIcon": "pnaTxa_sendButtonIcon",
  "spinner": "pnaTxa_spinner",
  "textarea": "pnaTxa_textarea",
});
